import { IDialog } from './IDialog';
import { OnInit, ElementRef } from '@angular/core';
// import { DialogPanelSide } from "./DialogPanelSide";
import * as $ from "jquery";

export class DialogPanelComponentContent implements IDialog {
    private marginSide: string;
    private targetElement: any;

    constructor(
        protected element: ElementRef,
        public alignRight: boolean,
        protected containerSelector: string = ".modal-panel") {

    }

    ngOnInit() {
        this.show();
    }

    /** Mostra o componente segundo comportamento esperado */
    show() {

        $(this.element.nativeElement).parents('.cdk-overlay-pane').addClass('modal-panel-overlay');
        this.targetElement = $(this.element.nativeElement)
            .parents('.mat-dialog-container')
            .parents('.cdk-overlay-pane');
        $(this.element.nativeElement).find(this.containerSelector).show();

        if (this.alignRight)
            this.targetElement.delay(0).css({ 'margin-right': '-100%' }).animate({ 'margin-right': "0" }, "slow");
        else
            this.targetElement.delay(0).css({ 'margin-left': '-100%' }).animate({ 'margin-left': "0" }, "slow");
    }

    /** Realiza o dispose do componente */
    close(dialogReference: any, result: any) {

        if (this.alignRight)
            this.targetElement.delay(150).css({ 'margin-right': '0' }).animate({ 'margin-right': "-100%" }, "slow");
        else
            this.targetElement.delay(150).css({ 'margin-left': '0' }).animate({ 'margin-left': "-100%" }, "slow");

        //espera a animação de saída
        setTimeout(function () {
            dialogReference.close(result);
        }, 400);
    }
}